/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import $ from 'jquery'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import Select from 'react-select'
import cookie from 'react-cookies'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import SearchableCombo from '../BaseComponent/searchableCombo'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class Remains extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      providerId: '',
      loading: false,
      Remains: [],
      printInfo: [],
      lengthRemains: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'warehouseName_asc,productName_desc',
      getSort: '',
      modal: false,
      selectedOption: [],
      wareHousesname: [],
      wareType: [],
      providerText: '',
      wareText: '',
      wareTextPrint: '',
      buttonClicked: false,
      warehouseId: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کد محصول',
          value: 'articleId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'بارکد محصول',
          value: 'productCode',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام محصول',
          value: 'productName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد',
          value: 'quantity',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'انبار',
          value: 'warehouseName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تامین کننده',
          value: 'providerName',
          sorted: true,
          direction: null,
          sortable: true
        }
      ]
    }
  }

  quantity() {
    let quantitymin = Number(document.getElementById('quantitymin').value)
    // let quantitymax=Number(document.getElementById('quantitymax').value);
    document.getElementById('quantitymax').value = quantitymin + 1
    let quantitymax = document.getElementById('quantitymax').value
  }
  getAllRemains = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_REMAIN}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable').fadeIn()
          if (!exportStatus) {
            this.setState({
              tablePageNumber: this.state.pageNumber,
              tablePageSize: this.state.pageSize,
              Remains: response.data.object.result,
              lengthRemains: response.data.object.countAll,
              providerText:
                this.state.selectedOption == null || this.state.selectedOption == ''
                  ? ''
                  : this.state.selectedOption.title,
              wareTextPrint: this.state.wareText,
              buttonClicked: true,
              loading: false
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          this.setState({
            Remains: [],
            loading: false
          })
          $('.showBaseTable').fadeOut()
          // message.error(response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  componentDidMount() {
    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_PRIMARYWAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            wareType: response.data.object
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error === null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].id
            result[i]['label'] = result[i].id + ' - ' + result[i].name + ' ( ' + result[i].typePrimaryName + ' ) '
          }
          this.setState({
            wareHousesname: response.data.object
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })

    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then(response => {
    //     if (response.data.error == null) {
    //       var result = response.data.object;
    //       for (let i = 0; i < result.length; i++) {
    //         result[i]["value"] = result[i].providerId;
    //         result[i]["label"] = result[i].providerId + " - " + result[i].title;
    //       }

    //       this.setState({
    //         providers: response.data.object
    //       });
    //     }
    //     // alert(JSON.stringify(response.data))
    //   })
    //   .catch(error => {
    //     alert(JSON.stringify(error));
    //   });

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      Remains: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Remains: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(selectedOption)

    console.log(`Option selected:`, selectedOption)
  }

  changeWarehouse(e) {
    let target = e.target
    this.setState({
      wareText: target.options[target.selectedIndex].text
    })
  }

  getValueWarehouse = (warehouseId) => {
    this.setState({
      warehouseId,
      wareText: warehouseId === '' || warehouseId === null ? ' ' : warehouseId.name
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAllRemains(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAllRemains(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAllRemains(false)
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let productArticleId = document.getElementById('productArticleId').value
    var typePrimary = document.getElementById('typePrimary').value
    let productCode = this.convertDigit(document.getElementById('productCode').value)
    let productName = document.getElementById('productName').value
    let quantitymin = this.convertDigit(document.getElementById('quantitymin').value)
    let quantitymax = this.convertDigit(document.getElementById('quantitymax').value)
    let typeWarehouseId =
      this.state.warehouseId == null || this.state.warehouseId == '' ? '' : this.state.warehouseId.id
    var providerId = this.state.providerId

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (productArticleId !== '' && productArticleId.length) {
      filter.articleId = productArticleId.trim()
    }
    if (typePrimary !== '' && typePrimary.length) {
      filter.typePrimary = typePrimary
    }
    if (productCode !== '' && productCode.length) {
      filter.productCode = productCode.trim()
    }
    if (productName !== '' && productName.length) {
      filter.productName = productName.trim()
    }
    if (quantitymin !== '' && quantitymin.length) {
      filter.quantityMin = quantitymin.trim()
    }
    if (quantitymax !== '' && quantitymax.length) {
      filter.quantityMax = quantitymax.trim()
    }
    if (typeWarehouseId !== '') {
      filter.typeWarehouseId = typeWarehouseId
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }

    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.getAllRemains(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  getPrintInfo = () => {
    this.getAllRemains(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_REMAIN}`, {params: filter})
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  dynamicBreadTitle = () => {
    let urlParams = new URLSearchParams(window.location.search)
    let from = !urlParams.get('from') ? '' : urlParams.get('from')
    if (!from) return ''
    else if (from === 'inventory') return <li>انبار</li>
    else return <li>مالی</li>
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let {selectedOption} = this.state

    let params = sessionStorage.getItem('params')
    let name = cookie.load('name')
    let columns = ['ردیف', 'کد محصول', 'بارکد محصول', 'نام محصول', 'تعداد', 'نام انبار', 'تامین کننده']

    let excelColumns = [
      {title: 'کد محصول', value: 'articleId'},
      {title: 'بارکد محصول', value: 'productCode'},
      {title: 'نام محصول', value: 'productName'},
      {title: 'نام انبار', value: 'warehouseName'},
      {title: 'نام تامین کننده', value: 'providerName'}
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش موجودی انبار"
              headerColSpan={7}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={2}
              centerColSpan={3}
              centerSection={'تامین کننده : ' + this.state.providerText}
              rightSection={'موجودی برای انبار : ' + this.state.wareTextPrint}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((remains, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{remains.articleId}</td>
                  <td>{remains.productCode}</td>
                  <td>{remains.productName}</td>
                  <td>{remains.quantity}</td>
                  <td>{remains.warehouseName}</td>
                  <td>{remains.providerName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش مانده انبار.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'articleId'}
                field={'articleId'}
                title={'کد محصول '}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productCode'}
                field={'productCode'}
                title={'بارکد محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productName'}
                field={'productName'}
                title={'نام محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'quantity'}
                field={'quantity'}
                title={'تعداد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn key={'warehouseName'} field={'warehouseName'} title={'انبار'} />

              <gridColumn key={'providerName'} field={'providerName'} title={'تامین کننده'} />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            {this.dynamicBreadTitle()}
            <li>لیست موجودی</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/Remains'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>کد محصول : </label>
                  <input className="form-control" type="text" id="productArticleId" />
                </div>
                <div className="formComponent">
                  <label>بارکد محصول:</label>
                  <input className="form-control" type="text" id="productCode" />
                </div>
                <div className="formComponent">
                  <label>نام کالا:</label>
                  <input className="form-control" type="text" id="productName" />
                </div>
                <div className="formComponent">
                  <label>تعداد کالا از:</label>
                  <input className="form-control" type="number" onChange={this.quantity.bind(this)} id="quantitymin" />
                </div>

                <div className="formComponent">
                  <label>تعداد کالا تا:</label>
                  <input className="form-control" type="number" id="quantitymax" />
                </div>
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.wareHousesname}
                    getValueCombo={this.getValueWarehouse}
                    lableText="نام انبار"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>

                <div className="formComponent">
                  <label>نوع انبار </label>
                  <select className="form-control" id="typePrimary" name="typePrimary">
                    <option value="">---------</option>
                    {this.state.wareType.map((wareType, index) => (
                      <option key={index} value={wareType.id}>
                        {wareType.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>نام تامین کننده:</label>
                  <Select
                    value={selectedOption}
                    onChange={this.handleChange}
                    options={this.state.providers}
                    isMulti={false}
                    isClearable={true}
                    id="providerId"
                    placeholder=""
                  /> */}
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.Remains.map((remains, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>{remains.articleId}</td>
                      <td>{remains.productCode}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: remains.articleId})}>
                          {remains.productName}
                        </a>
                      </td>
                      <td>{remains.quantity}</td>
                      <td>{remains.warehouseName}</td>
                      <td>{remains.providerName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthRemains}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Remains
